import { tVector4 } from '../Utility/ArrayHelper';
import DateHelper from '../Utility/DateHelper';
import { PetId } from './Pets';

export const dailyLoginTimerDuration: number = DateHelper.Day;
export const maxDailyLoginStreak: number = 7;

export const dailyLoginUTCTime: tVector4 = [6, 0, 0, 0];

export interface IClaimedDailyLoginReward {
    id: string;
    date: Date;
}

export const petDayIndex: number = 2;

export const dailyLoginPet: PetId = PetId.Charly;
